$(window).on('load', function() {
  
  $(".popup-shiping, .zip-learn-more").on('click', function() {
    $('body').addClass('model-active');
    $(".custom-model-main").addClass('model-open');
  }); 
  $(".popup-features").on('click', function() {
    $('body').addClass('model-active');
    $(".custom-model-features").addClass('model-open');
  }); 
  $(".close-popup-features").on('click', function() {
    $('body').removeClass('model-active');
    $(".custom-model-features").removeClass('model-open');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $('body').removeClass('model-active');
    $(".custom-model-main").removeClass('model-open');
  });
  

  
  if($('.uniquesellingpoints').length){
    $('.uniquesellingpoints').insertAfter('.product-gallery .product-gallery__media-list-wrapper');
    $('.uniquesellingpoints').show();
  }
  $( ".metafield-multi_line_text_field" ).each(function( index ) {
    var meta_specification = $(this).text();
    if(meta_specification.indexOf(".jpg") != -1 || meta_specification.indexOf(".JPGE") != -1 || meta_specification.indexOf(".png") != -1){
        if(meta_specification.indexOf("<img") == -1){
          meta_specification = '<img src="'+meta_specification+'"/>';
        }
    }
    $(this).html(meta_specification);
   });
});
$( document ).ready(function() {
  
  
  if($(window).width() <767){
    if($('.desktop-video').length){
      $(".desktop-video").remove();
    }
    $('.footer__block--menu p, .footer__block--text p ').click(function(){
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $(this).parent().addClass('active');
      }
      
    });
  }else{
    if($('.mobile-video').length){
      $(".mobile-video").remove();
    }
  }

  
  $('.product-info__text').each(function() {
  if ($(this).text().trim().toLowerCase() === 'nopresale') {
    $(this).hide();
  }
});
});

$( window ).on( "resize", function() {
  if($(window).width() <767){
    
    $('.footer__block--menu p, .footer__block--text p ').click(function(){
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $(this).parent().addClass('active');
      }
      
    });
  }
} );